import * as React from "react";
import styled from "styled-components";

const NearbyRestaurantsContainer = styled.div`
  margin-top: 6rem;
  @media (max-width: 680px) {
    margin-right: 1.5rem;
  }
`;
const NearbyRestaurantsTitle = styled.h2`
  margin-top: 4rem;
  margin-bottom: 2rem;
  font-size: 2.2rem;
  text-align: center;
`;
const NearbyRestaurantsList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 3rem;
  margin-top: 1rem;
  justify-content: flex-start;
`;
const NearbyRestaurant = styled.a`
  width: 300px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 1rem;
  padding: 1rem 2rem;
  background: #fff;
  border-radius: 1rem;
  justify-content: center;
  font-size: 1.4rem;
  cursor: pointer;
  @media (max-width: 680px) {
    width: 100%;
  }
`;

export const NearbyRestaurants = ({ locale, nearbyRestaurants }) => {
	return (<NearbyRestaurantsContainer>
		<NearbyRestaurantsTitle>{locale === "en" ? "Nearby Restaurants" : "附近餐廳"}</NearbyRestaurantsTitle>
		<NearbyRestaurantsList>
			{nearbyRestaurants && nearbyRestaurants.length > 0 && nearbyRestaurants.map((restaurant, index) => {
				const url = locale === "en" ? `/en/contact-us/${restaurant.slug}` : `/contact-us/${restaurant.slug}`;
				return <NearbyRestaurant href={url} key={index}>{restaurant.name}</NearbyRestaurant>
			})}
		</NearbyRestaurantsList>
	</NearbyRestaurantsContainer>);
};
